import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModelProfileEditor from '../../components/components-model/ModelProfileEditor';
import { fetchMyModelService } from '../../services/panelService';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';
import '../admin/admin.css';

/**
 * Mi perfil público, tal como lo ve el visitante.
 *
 * Reutiliza el mismo editor que usa el panel de administración; lo que cambia
 * es de dónde sale el perfil: aquí de `/me/model`, porque la modelo no tiene
 * acceso al listado desde el que un administrador elige a quién edita.
 */
export default function MyProfile() {
    useDocumentMeta({ title: 'Mi perfil', noIndex: true });

    const [model, setModel] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;

        fetchMyModelService()
            .then((data) => active && setModel(data))
            .catch((err) => active && setError(err.message))
            .finally(() => active && setLoading(false));

        return () => {
            active = false;
        };
    }, []);

    return (
        <div className="admin-container">
            <Container fluid>
                <div className="admin-header">
                    <div>
                        <h2 className="admin-title">Mi perfil público</h2>
                        <p className="text-muted small mb-0">
                            Esto es lo que ve quien entra a tu página.
                            {model?.slug && (
                                <>
                                    {' '}
                                    <Link to={`/modelo/${model.slug}`} className="profile-link ms-1">
                                        <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                                        <span>Verla</span>
                                    </Link>
                                </>
                            )}
                        </p>
                    </div>
                </div>

                {loading && <p className="text-muted text-center py-5">Cargando tu perfil...</p>}

                {error && !loading && (
                    <div className="alert alert-danger">{error}</div>
                )}

                {model && <ModelProfileEditor model={model} onSaved={setModel} />}
            </Container>
        </div>
    );
}
